import { FormatDateOptions } from 'react-intl';

export const intlDateFormat: FormatDateOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};
